import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";
import { FaUndo, FaExchangeAlt, FaEnvelope, FaPhone } from "react-icons/fa";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="info-page returns">
      <Header />

      <div className="info-page__breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>
        <span>/</span>
        <span>Return Policy</span>
      </div>

      <div className="info-page__content">
        <div className="info-page__main">
          <h1 className="info-page__title">Return Policy</h1>

          <p className="info-page__intro">
            We want you and your pet to be happy with your purchase. If you're
            not completely satisfied, we offer a hassle-free return process.
          </p>

          <section className="info-section">
            <h2 className="info-section__title">30-Day Return Window</h2>
            <p>
              We accept returns within 30 days of purchase for most items.
              Products must be in their original condition with all tags
              attached. Due to the nature of pet products, certain items may
              have specific return restrictions.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Eligible Items</h2>
            <div className="eligibility-grid">
              <div className="eligibility-card eligibility-card--yes">
                <h3>
                  <FaUndo className="card-icon" /> Eligible for Return
                </h3>
                <ul className="eligibility-list">
                  <li>Unopened toys in original packaging</li>
                  <li>Beds with no pet hair or odors</li>
                  <li>Accessories with original tags attached</li>
                  <li>Items purchased within 30 days</li>
                </ul>
              </div>
              <div className="eligibility-card eligibility-card--no">
                <h3>
                  <FaExchangeAlt className="card-icon" /> Not Eligible for
                  Return
                </h3>
                <ul className="eligibility-list">
                  <li>Opened toys (health and safety)</li>
                  <li>Items with pet hair or odors</li>
                  <li>Customized or personalized products</li>
                  <li>Final sale or clearance items</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">How to Return</h2>
            <h3 className="info-subsection__title">
              Step 1: Initiate Your Return
            </h3>
            <p>
              Contact our customer service team via email or phone to obtain a
              Return Authorization (RA) number. Please have your order number
              ready.
            </p>

            <h3 className="info-subsection__title">Step 2: Pack Your Item</h3>
            <p>
              Place the item in its original packaging if possible. Include a
              copy of your order confirmation or receipt inside the package.
            </p>

            <h3 className="info-subsection__title">Step 3: Ship Your Return</h3>
            <p>
              Send the package to the address provided with our customer service
              team. We recommend using a trackable shipping method.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Refunds</h2>
            <p>
              Once we receive and inspect your return, we will process your
              refund within 5-7 business days. Refunds will be credited to your
              original payment method.
            </p>
            <p>
              <strong>Shipping costs</strong> are non-refundable unless the
              return is due to our error (wrong item shipped, defective
              product).
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Exchanges</h2>
            <p>
              If you need to exchange an item for a different size or color,
              please contact us. We'll be happy to assist you with the exchange
              process.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Damaged or Defective Items</h2>
            <p>
              If you receive a damaged or defective product, please contact us
              within 5 days of delivery. We will arrange for a replacement or
              refund at no additional cost to you. Please keep the original
              packaging as we may request photos for verification.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Warranty Information</h2>
            <p>
              Some products come with a manufacturer's warranty. Please check
              the product packaging or contact us for warranty details on
              specific items.
            </p>
          </section>

          <div className="info-notice">
            <p>
              <strong>Note:</strong> This return policy applies to purchases
              made directly through playpetbrands.com. Items purchased from
              third-party retailers may be subject to their individual return
              policies.
            </p>
          </div>
        </div>

        <aside className="info-page__sidebar">
          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Need to Return?</h3>
            <p className="sidebar-card__text">
              Contact our customer service team to initiate your return and get
              your Return Authorization number.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>split@petmorvanto.club</span>
              </div>
            </div>
          </div>

          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Quick Links</h3>
            <ul className="sidebar-links">
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping Information
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
